export const PUBNUB_AUTH_ENDPOINT = '/c/v1/pubnub/auth';
